module.exports = __webpack_public_path__ + "img/main_kfw.2a1282be.jpg";